(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function() {
    // Runs for EVERY signup block on the page. querySelector would only ever
    // find the first one, leaving a second block (footer + section, say) with no
    // JS at all.
    function initEmailSignup(block) {
      if (!block || block.dataset.emailSignupInit) return;
      block.dataset.emailSignupInit = '1';

      const form = block.querySelector('form');
      const emailInput = block.querySelector('input[type="email"]');
      const validationMsg = block.querySelector('[id^="Email-signup__message-validation"]');
      const serverMsgs = block.querySelectorAll('[id^="Email-signup__message-error"], [id^="Email-signup__message-success"]');
      const submitButton = block.querySelector('.email-signup__button');

      if (!form || !emailInput || !validationMsg) return;

      const klaviyoPublicKey = block.dataset.klaviyoPublicKey || '';
      const klaviyoListId = block.dataset.klaviyoListId || '';

      const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
      let submitting = false;

      function validateEmail() {
        const value = emailInput.value.trim();
        if (value.length === 0) {
          validationMsg.style.display = 'none';
          emailInput.classList.remove('email-signup__input--invalid');
          return true;
        }
        if (!emailRegex.test(value)) {
          validationMsg.style.display = 'flex';
          emailInput.classList.add('email-signup__input--invalid');
          return false;
        }
        validationMsg.style.display = 'none';
        emailInput.classList.remove('email-signup__input--invalid');
        return true;
      }

      emailInput.addEventListener('input', function() {
        if (emailInput.classList.contains('email-signup__input--invalid')) validateEmail();
        // A message rendered by the previous page load is stale once they retype.
        serverMsgs.forEach(function(el) { el.style.display = 'none'; });
      });

      emailInput.addEventListener('blur', validateEmail);

      function subscribeToKlaviyo(email) {
        return fetch(
          'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klaviyoPublicKey),
          {
            method: 'POST',
            keepalive: true, // lets the request finish even as the page navigates
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email: email }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: { type: 'list', id: klaviyoListId }
                  }
                }
              }
            })
          }
        );
      }

      const pendingKey = 'emailSignupPending:' + block.dataset.blockId;
      const jsSuccessMsg = block.querySelector('[id^="Email-signup__message-success-js"]');
      const serverSuccess = block.querySelector('[id^="Email-signup__message-success-"]:not([id^="Email-signup__message-success-js"])');
      const serverError = block.querySelector('[id^="Email-signup__message-error"]');

      // Runs on the page we land on after the submit.
      (function showPendingSuccess() {
        let pending = null;
        try { pending = sessionStorage.getItem(pendingKey); } catch (err) { /* private mode */ }
        if (!pending) return;
        try { sessionStorage.removeItem(pendingKey); } catch (err) {}
        // The server had its say: an error wins, its own success is enough.
        if (serverError || serverSuccess) return;
        if (jsSuccessMsg) {
          jsSuccessMsg.style.display = 'flex';
          jsSuccessMsg.focus();
        }
      })();

      form.addEventListener('submit', function(e) {
        if (submitting) return; // our own native submit, let it through

        const email = emailInput.value.trim();

        // Never let an empty form reach Shopify — an empty contact[email] is
        // exactly what renders "Email can't be blank" on the next page.
        if (!email) {
          e.preventDefault();
          emailInput.focus();
          return;
        }

        if (!validateEmail()) {
          e.preventDefault();
          emailInput.focus();
          return;
        }

        if (!klaviyoPublicKey || !klaviyoListId) {
          // Native post, nothing to add — just remember it happened.
          try { sessionStorage.setItem(pendingKey, '1'); } catch (err) {}
          return;
        }

        // Hold the native post just long enough to register the Klaviyo profile,
        // then submit for real. The reload is what creates the Shopify customer
        // and renders Shopify's own success message — the field is never cleared
        // beforehand, so the email always reaches the server.
        e.preventDefault();
        if (submitButton) submitButton.disabled = true;

        function go() {
          if (submitting) return;
          submitting = true;
          try { sessionStorage.setItem(pendingKey, '1'); } catch (err) { /* private mode */ }
          if (submitButton) submitButton.disabled = false; // a disabled control is not submitted
          form.submit(); // native submit: bypasses this handler, no recursion
        }

        const klaviyoDone = subscribeToKlaviyo(email)
          .then(function(res) {
            if (!(res.ok || res.status === 202)) console.error('Klaviyo subscribe failed:', res.status);
          })
          .catch(function(err) { console.error('Klaviyo subscribe error:', err); });

        // Whatever Klaviyo does, the Shopify submit happens — capped at 3s so a
        // slow or blocked request never strands the visitor.
        Promise.race([klaviyoDone, new Promise(function(r) { setTimeout(r, 3000); })]).then(go, go);
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('.email-signup-block').forEach(initEmailSignup);
    }

    initAll();
    document.addEventListener('shopify:section:load', function(e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function(e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
